<ng-template #loadingOrError>
  <ng-container *ngIf="error$ | async as error;else loading">
    <h3>Fehler beim Laden automatisierte Daten: {{error.valueOf()}}</h3>
  </ng-container>
  <ng-template #loading>
    <app-progress-indicator inProgress="true"></app-progress-indicator>
  </ng-template>
</ng-template>

<ng-container *ngIf="vorhersagen$ | async as vorhersagen; else loadingOrError">
  <mat-tab-group [selectedIndex]="selectedIndex">
    <ng-container *ngIf="hasBlnBrbFilterSet()">
      <mat-tab label="RBB Aktuell">
        <app-automatisiert-rbb-aktuell [vorhersagen]="vorhersagen"></app-automatisiert-rbb-aktuell>
      </mat-tab>
      <mat-tab label="Brandenburg Aktuell">
        <app-automatisiert-brandenburg-aktuell [vorhersagen]="vorhersagen"></app-automatisiert-brandenburg-aktuell>
      </mat-tab>
    </ng-container>
  </mat-tab-group>
</ng-container>

<div class="no-content-message" *ngIf="!bundeslandFilter.getSelectedBundesLaenderNamen().includes('Brandenburg')">
  <p>Keine Daten vorhanden, evtl. müssen Sie einen Filter einstellen</p>
</div>

